export const inputClass = (error?: string) =>
    `w-full border-[1.5px] rounded-[10px] px-3 py-2.5 text-sm text-text-primary bg-cream outline-none transition-all focus:bg-white focus:shadow-[0_0_0_3px_rgba(45,106,79,0.10)] text-right placeholder:text-text-muted ${
      error
        ? 'border-[#E74C3C] focus:border-[#E74C3C] focus:shadow-[0_0_0_3px_rgba(231,76,60,0.10)]'
        : 'border-cream-dark focus:border-green-primary'
    }`
  
export const labelClass = 'text-xs font-semibold text-text-secondary mb-1 block'